import { translate } from '@gig/magic-common';
import { ValidationDisplay } from '@gig/magic-form-builder';

function userLabel() {
    return {
        id: 'userLabel',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'userLabel',
        properties: {
            placeholder: translate('totp.corex.userLabel.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        isOptional: true,
    };
}

export { userLabel };
